import React, { useState, useEffect } from 'react'
import config from '../../resource/config.js'
import StatusActions from '../../actions/StatusActions.js'
import CancelAction from '../../actions/CancelAction.js'
import TimedOutAction from '../../actions/TimedOutAction.js'
import RequestStatusGuide from '../../components/panels/RequestStatusGuide.js'
import '../../css/style.css'
import appConfig from '../../resource/appConfig.js'

const api = config.apiBaseUrl + 'apbe/requeststatus',
    VIP = appConfig.reqStatuses.validationInProgress,
    FF = appConfig.reqStatuses.fulfilled,
    FwF = appConfig.reqStatuses.fulfilledWithFailures,
    TO = appConfig.reqStatuses.timedOut
const requestsCountLimit = appConfig.requestsCountLimit

const RequestStatusPage = props => {
    const [requests, setRequests] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        handleFetch(global.currentReqStatus)
        let interval
        try {
            interval = setInterval(async () => {
                handleFetch(global.currentReqStatus)
                if (global.currentReqStatus && global.currentReqStatus !== VIP) {
                    clearInterval(interval)
                }
            }, 5000)
        } catch (e) {
            console.log(e)
        }

        return () => {
            if (interval) clearInterval(interval)
        }
    }, [])

    const handleFetch = reqStatus => {
        //handlehandleFetch will be called for VALIDATION IN PROGRESS,undefined,intialCall for every 5 seconds
        if (!reqStatus || reqStatus === VIP) {
            const requestParams = {
                orgid: props.fDataItems.ORG_ID,
                cognitoId: props.fDataItems.COGNITO_ID,
                coord: props.fDataItems.COORDINATOR,
                reqid: props.fDataItems.REQUEST_ID
            }
            fetch(api, {
                method: 'POST',
                dataType: 'jsonp',
                headers: props.apiAuthHeaders,
                body: JSON.stringify(requestParams)
            }).then((response) => {
                return response.json()
            }).then((responseData) => {
                if (responseData.requests) {
                    setRequests(responseData.requests)
                }
                setIsLoading(false)
            }).catch(function (err) {
                console.log(err)
            })
        }
    }

    let currentRequest = requests ? requests[0] : {}
    let requestCount = props.requestCount
    global.currentReqStatus = currentRequest && currentRequest.REQ_STATUS ? currentRequest.REQ_STATUS : undefined
    return (
        <div className="container">
            <div className="row">
                {isLoading ? <div role="progressbar" aria-valuetext="Loading…"
                                  className="cb-loader cb-loader-blue cb-loader-lg"></div> :
                    <div className="col-md-12">
                        <div className="cb-panel-white">
                            <div
                                className={requestCount < requestsCountLimit && (currentRequest.UPLOAD_TYPE === "4" || currentRequest.REQ_STATUS === FF || currentRequest.REQ_STATUS === FwF) ? "upload-block" : "hidden"}>
                                <a tabIndex="0" href="/newRequest"
                                   className="btn btn-primary btn-sm cb-margin-left-16 upload create-new-request-button">Create
                                    New Request</a>
                            </div>
                            <div aria-live="polite" aria-label="Instructions" tabIndex="0">
                                <RequestStatusGuide currentRequest={currentRequest} />
                            </div>
                            <h2>Bulk Enrollment Request</h2>
                            <div>
                                {
                                    requests ? requests.map((request, index) => {
                                        return (
                                            <div className="request-status-wrapper" key={index}>
                                                <div key={index}
                                                     className="panel-body custom-panel request-status-panel">
                                                    {
                                                        (request && (request.UPLOAD_TYPE === "4")) ?
                                                            (
                                                                <CancelAction apiAuthHeaders={props.apiAuthHeaders}
                                                                              request={request}
                                                                              index={requests.length - index} />
                                                            ) : (request && (request.REQ_STATUS === TO)) ?
                                                                (
                                                                    <TimedOutAction apiAuthHeaders={props.apiAuthHeaders}
                                                                                    request={request}
                                                                                    index={requests.length - index} />
                                                                ) :
                                                                (
                                                                    <StatusActions apiAuthHeaders={props.apiAuthHeaders}
                                                                                   request={request}
                                                                                   index={requests.length - index} />
                                                                )
                                                    }
                                                </div>
                                                {
                                                    (requests.length === 1) ? null : (index === 0) ?
                                                        (
                                                            <h2>Request History</h2>
                                                        ) : null
                                                }
                                            </div>
                                        )
                                    }) : null
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export default RequestStatusPage
